class CollectionLayout extends HTMLElement {
    constructor() {
        super();
        var e = this.querySelectorAll("div[data-layout]")
          , r = this.closest(".main-collection")
          , i = null;
        e && e.forEach(e => {
            e.addEventListener("click", function(e) {
                e.preventDefault();
                var e = r.querySelectorAll(".collection__product")
                  , t = this.getAttribute("data-layout");
                this.classList.toggle("active"),
                null != i && i.classList.toggle("active"),
                i = this,
                e.forEach(e => {
                    e.className = "flex__item collection__product aos-init aos-animate " + t
                }
                )
            })
        }
        )
    }
}
customElements.define("collection-layout", CollectionLayout);
class PriceRange extends HTMLElement {
    constructor() {
        super(),
        this.defaultStep = 5,
        this.selectors = {
            priceRange: ".price-range",
            priceRangeSlider: ".price-range__slider",
            priceRangeInputMin: ".price-range__input-min",
            priceRangeInputMax: ".price-range__input-max",
            priceRangeDisplayMin: ".price-range__display-min",
            priceRangeDisplayMax: ".price-range__display-max",
            priceText: ".filters__price_selected"
        },
        (this.container = this).sliderEl = this.container.querySelector(this.selectors.priceRangeSlider),
        this.inputMinEl = this.container.querySelector(this.selectors.priceRangeInputMin),
        this.inputMaxEl = this.container.querySelector(this.selectors.priceRangeInputMax),
        this.displayMinEl = this.container.querySelector(this.selectors.priceRangeDisplayMin),
        this.displayMaxEl = this.container.querySelector(this.selectors.priceRangeDisplayMax),
        this.formEl = this.container.closest("form"),
        this.priceTexteEl = this.formEl.querySelector(this.selectors.priceText),
        this.minRange = parseFloat(this.container.dataset.min) || 0,
        this.minValue = parseFloat(this.container.dataset.minValue) || 0,
        this.maxRange = parseFloat(this.container.dataset.max) || 100,
        this.maxValue = parseFloat(this.container.dataset.maxValue) || this.maxRange;
        try {
            this.createPriceRange()
        } catch (e) {
            console.log(e)
        }
    }
    createPriceRange() {
        this.sliderEl && this.sliderEl.noUiSlider && "function" == typeof this.sliderEl.noUiSlider.destroy && this.sliderEl.noUiSlider.destroy();
        var e = noUiSlider.create(this.sliderEl, {
            connect: !0,
            step: this.defaultStep,
            start: [this.minValue, this.maxValue],
            range: {
                min: this.minRange,
                max: this.maxRange
            }
        });
        return e.on("update", e => {
            this.displayMinEl.innerHTML = theme.Currency.formatMoney(parseFloat(e[0]), theme.moneyFormat),
            this.displayMaxEl.innerHTML = theme.Currency.formatMoney(parseFloat(e[1]), theme.moneyFormat),
            this.priceTexteEl && (this.priceTexteEl.innerHTML = theme.Currency.formatMoney(parseFloat(e[0]), theme.moneyFormat) + " - " + theme.Currency.formatMoney(parseFloat(e[1]), theme.moneyFormat))
        }
        ),
        e.on("change", e => {
            this.inputMinEl.setAttribute("value", parseFloat(e[0] / 100)),
            this.inputMaxEl.setAttribute("value", parseFloat(e[1] / 100)),
            this.formEl.dispatchEvent(new Event("input",{
                bubbles: !0
            }))
        }
        ),
        e
    }
}
customElements.define("price-range", PriceRange);
class CollectionFilters extends HTMLElement {
    constructor() {
        super(),
        this.filterData = [],
        this.onActiveFilterClick = this.onActiveFilterClick.bind(this),
        this.foldAllButton = this.querySelector(".link_collapsing_all_button"),
        this.debouncedOnSubmit = theme.utils.debounce(500, e => {
            this.onSubmitHandler(e)
        }
        ),
        this.querySelector("form").addEventListener("input", this.debouncedOnSubmit.bind(this)),
        window.addEventListener("popstate", this.onHistoryChange.bind(this)),
        this.bindEvents()
    }
    bindEvents() {
        var e = this;
        document.querySelectorAll(".js-filter-remove").forEach(e => {
            e.addEventListener("click", this.onActiveFilterClick, {
                once: !0
            })
        }
        ),
        this.foldAllButton && this.foldAllButton.addEventListener("click", function() {
            e.querySelectorAll(".filters__disclosure[open]").forEach(e => {
                e.removeAttribute("open")
            }
            )
        })
    }
    onSubmitHandler(e) {
        e.preventDefault();
        var t = new FormData(e.target.closest("form"))
          , t = new URLSearchParams(t).toString();
        this.renderPage(t, e)
    }
    onActiveFilterClick(e) {
        e.preventDefault(),
        this.toggleActivefilters(),
        this.renderPage(new URL(e.currentTarget.href).searchParams.toString())
    }
    onHistoryChange(e) {
        e = e.state ? e.state.searchParams : "";
        this.renderPage(e, null, !1)
    }
    toggleActivefilters(t=!0) {
        document.querySelectorAll(".js-filter-remove").forEach(e => {
            e.classList.toggle("disabled", t)
        }
        )
    }
    renderPage(i, n, e=!0) {
        const t = this.getSections();
        document.getElementById("productsGrid").classList.add("loading"),
        t.forEach(e => {
            const t = `${window.location.pathname}?section_id=${e.section}&${i}`;
            var r = e => e.url === t;
            this.filterData.some(r) ? this.renderSectionFromCache(r, e, n) : this.renderSectionFromFetch(t, e, n)
        }
        ),
        e && this.updateURLHash(i)
    }
    renderSectionFromFetch(t, e, r) {
        fetch(t).then(e => e.text()).then(e => {
            this.filterData = [...this.filterData, {
                html: e,
                url: t
            }],
            this.renderFilters(e, r),
            this.renderSort(e, r),
            this.renderProductGrid(e),
            this.renderPagination(e)
        }
        )
    }
    renderSectionFromCache(e, t, r) {
        e = this.filterData.find(e).html;
        this.renderFilters(e, r),
        this.renderSort(e, r),
        this.renderProductGrid(e),
        this.renderPagination(e)
    }
    renderSort(e, t) {
        (new DOMParser).parseFromString(e, "text/html").querySelector(".filters__sorting") && (e = (new DOMParser).parseFromString(e, "text/html").querySelector(".filters__sorting").innerHTML,
        document.querySelector(".filters__sorting").innerHTML = e)
    }
    renderProductGrid(e) {
        e = (new DOMParser).parseFromString(e, "text/html").getElementById("productsGrid").innerHTML;
        document.getElementById("productsGrid").innerHTML = e,
        document.getElementById("productsGrid").querySelectorAll("img", "svg").forEach(e => {
            theme.utils.lazyBackgroundObserver.observe(e)
        }
        ),
        document.getElementById("productsGrid").classList.remove("loading")
    }
    renderPagination(e) {
        e = (new DOMParser).parseFromString(e, "text/html").querySelector(".collection_pagination");
        (document.querySelector(".collection_pagination") || e) && (document.querySelector(".collection_pagination").innerHTML = e ? e.innerHTML : "")
    }
    renderFilters(e, t) {
        const r = (new DOMParser).parseFromString(e, "text/html");
        e = r.querySelectorAll("#CollectionFiltersForm .js-filter, #CollectionFiltersFormMobile .js-filter");
        const i = e => (t && t.target.closest(".js-filter") ? t.target.closest(".js-filter").dataset.index : "") === e.dataset.index
          , n = Array.from(e).filter(e => !i(e));
        e = Array.from(e).find(i);
        n.forEach(e => {
            document.querySelector(`.js-filter[data-index="${e.dataset.index}"]`).innerHTML = e.innerHTML
        }
        ),
        this.renderActivefilters(r),
        this.renderMobileElements(r),
        e && this.renderCounts(e, t.target.closest(".js-filter"));
        e = new CustomEvent("reloadfilter");
        document.dispatchEvent(e)
    }
    renderActivefilters(r) {
        [".active-filters-mobile", ".active-filters-desktop"].forEach(e => {
            var t = r.querySelector(e);
            t && (document.querySelector(e).innerHTML = t.innerHTML)
        }
        ),
        this.bindEvents(),
        this.toggleActivefilters(!1)
    }
    renderMobileElements(t) {
        [".mobile-filters__open", ".mobile-filters__count"].forEach(e => {
            document.querySelector(e) && t.querySelector(e) && (document.querySelector(e).innerHTML = t.querySelector(e).innerHTML)
        }
        ),
        document.getElementById("CollectionFiltersFormMobile") && document.getElementById("CollectionFiltersFormMobile").closest("menu-drawer").bindEvents()
    }
    renderCounts(r, i) {
        [".count-bubble", ".filters__selected"].forEach(e => {
            var t = i.querySelector(e);
            r.querySelector(e) && t && (i.querySelector(e).outerHTML = r.querySelector(e).outerHTML)
        }
        )
    }
    updateURLHash(e) {
        history.pushState({
            searchParams: e
        }, "", `${window.location.pathname}${e && "?".concat(e)}`)
    }
    getSections() {
        return [{
            id: "main-collection-product-grid",
            section: document.getElementById("main-collection-product-grid").dataset.id
        }]
    }
}
customElements.define("collection-filters", CollectionFilters);
